import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import TranslationProvider from './translation/translationContext';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL!;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

root.render(
  <React.StrictMode>
    <TranslationProvider>
      <Provider store={store}>
        <BrowserRouter>
          <Auth0Provider
            domain={domain!}
            clientId={clientId!}
            authorizationParams={{
              redirect_uri: redirectUri,
              audience: audience,
            }}
          >
            <App />
          </Auth0Provider>
        </BrowserRouter>
      </Provider>
    </TranslationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
